import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import { addQuotes } from 'apps/utils';

import Paragraph from 'components/Paragraph';
import BaseCard from 'apps/notificationCenter/views/baseCard';

import { MinimalSpan } from 'apps/notificationCenter/styles';

const CommentCard = props => {
  const { notification } = props;
  const snippet = notification?.targetApp?.snippet;
  if (!notification || !snippet) return null;

  const message = (
    <>
      <Paragraph>
        <MinimalSpan>{props.t('said')}</MinimalSpan>
        {':'}&nbsp;
      </Paragraph>
      {snippet && <Paragraph as='blockquote'>{addQuotes(snippet)}</Paragraph>}
    </>
  );

  return <BaseCard notification={notification} message={message} />;
};

CommentCard.propTypes = {
  t: PropTypes.func,
  notification: PropTypes.object,
};

export default withNamespaces()(observer(CommentCard));
